import moment from 'moment';
moment.locale('fr');

export function relativeDate(date){
    let start = moment(date);
    let end = moment();
    let diff = end.diff(start, "days")

    if( diff>2 ) return moment(date).format('YY-MM-DD');

    moment.updateLocale('fr', {
        relativeTime : {
            future: "dans&nbsp;%s",
            past:   "%s",
            s  : '%d sec.',
            ss : '%d sec.',
            m:  "1 min.",
            mm: "%d&nbsp;min.",
            h:  "1h",
            hh: "%dh",
            d:  "1 jour",
            dd: "%d jours",
            w:  "a semaine",
            ww: "%d semaines",
            M:  "1 mois",
            MM: "%d mois",
            y:  "1 an",
            yy: "%d ans"
        }
    });

    return moment(start).fromNow();
}


export function getWeeksLimits(date, firstDayOfWeek = 0) {
    let curr=new Date();
    if (date) curr = new Date(moment(date));
    if(curr.getDay()<firstDayOfWeek) curr.setDate(curr.getDate()-7);

    let from = new Date(curr.setDate(curr.getDate() - curr.getDay() + parseInt(firstDayOfWeek)));
    let to = new Date(curr.setDate(curr.getDate() - curr.getDay() + 6 + parseInt(firstDayOfWeek)));

    return {
        obj: {
            from, 
            to
        },
        str: {
            from: moment(from).format("YYYY-MM-DD"),
            to: moment(to).format("YYYY-MM-DD")
        }
    }
}

export function getMonthLimits(date, length = null, offset = null) {
    if (date) date = new Date(moment(date));
    let from = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    // let to = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    // if (length && length > to.getDate()) to.setDate(to.getDate() + (length - to.getDate()))
    if (offset!==null) from.setDate(from.getDate() + offset)
    if (offset===null) from = new Date(date.getFullYear(), date.getMonth(), 1);
    let to = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    if (length) {
        to = new Date(from)
        to.setDate(from.getDate() + length)
    }
    // console.log('date : ', date, ' from : ', from, ' to : ', to)

    return {
        obj: {
            from, 
            to
        },
        str: {
            from: moment(from).format("YYYY-MM-DD"),
            to: moment(to).format("YYYY-MM-DD")
        }
    }
}

export function getDatesBetween(firstDate, secondDate){
    let dateRange=[], dates=[];
    if (firstDate) firstDate=new Date(moment(firstDate));
    if (secondDate) secondDate=new Date(moment(secondDate));

    dateRange.push(firstDate);
    dateRange.push(secondDate)
    dateRange.sort((a,b)=>a.getTime()-b.getTime());
    
    while (dateRange[0] <= dateRange[1]) {
        dates.push( new Date(dateRange[0]) )
        dateRange[0] = moment(dateRange[0]).add(1, 'days');
    }

    return dates;
}

export function dayOfWeekStr(date){
    if (date) date=new Date(moment(date));
    switch (date.getDay()) {
        case 0:
            return {short: "Dim.", full: "Dimanche"}
        case 1:
            return {short: "Lun.", full: "Lundi"}
        case 2:
            return {short: "Mar.", full: "Mardi"}
        case 3:
            return {short: "Mer.", full: "Mercredi"}
        case 4:
            return {short: "Jeu.", full: "Jeudi"}
        case 5:
            return {short: "Ven.", full: "Vendredi"}
        case 6:
            return {short: "Sam.", full: "Samedi"}
    }
}
export function monthStr(date){
    if (date) date=new Date(moment(date));
    switch (date.getMonth()) {
        case 0:
            return {short: "Janv.", full: "Janvier", month: date.getMonth()}
        case 1:
            return {short: "Fév.", full: "Février", month: date.getMonth()}
        case 2:
            return {short: "Mars", full: "Mars", month: date.getMonth()}
        case 3:
            return {short: "Avr.", full: "Avril", month: date.getMonth()}
        case 4:
            return {short: "Mai", full: "Mai", month: date.getMonth()}
        case 5:
            return {short: "Juin", full: "Juin", month: date.getMonth()}
        case 6:
            return {short: "Juil.", full: "Juillet", month: date.getMonth()}
        case 7:
            return {short: "Août", full: "Août", month: date.getMonth()}
        case 8:
            return {short: "Sept.", full: "Septembre", month: date.getMonth()}
        case 9:
            return {short: "Oct.", full: "Octobre", month: date.getMonth()}
        case 10:
            return {short: "Nov.", full: "Novembre", month: date.getMonth()}
        case 11:
            return {short: "Déc.", full: "Décembre", month: date.getMonth()}
    }
}

export function dayStr(day){
    if(day==1) return '1er';
    return day;
}

export function str2date(str) {
    return new Date(moment(str));
}

export function date2str(date) {
    return {
        short: moment(date).format("D MMM YYYY"),
        long: moment(date).format("D MMMM YYYY"),
        shortWd: moment(date).format("ddd D MMM YYYY"),
        longWd: moment(date).format("dddd D MMM YYYY"),
    }
}